import {Pipe, PipeTransform} from '@angular/core';
@Pipe ({
   name : 'Warranty'
})
export class Warranty implements PipeTransform {
   transform(val: string): string {

    switch (val) {
        case 'ASIS': return 'AS-IS';
        case '1DAY': return '1 Day';
        case '15DAYS': return '15 Days';
        case '30DAYS': return '30 Days';
        case '60DAYS': return '60 Days';
        case '6MONTHS': return '6 Months';
        case '1YEAR': return '1 Year';
    }

    return val;
   }
}